var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAddPhotoUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.75 6.688c.31 0 .563.253.563.562v11.243l-.176-.229-4.782-6.187a.846.846 0 0 0-1.336 0l-2.917 3.776-1.073-1.501A.838.838 0 0 0 9.344 14a.832.832 0 0 0-.686.355l-2.812 3.938-.159.218V7.25c0-.31.254-.563.563-.563h13.5zM6.25 5A2.252 2.252 0 0 0 4 7.25V18.5a2.252 2.252 0 0 0 2.25 2.25h13.5A2.252 2.252 0 0 0 22 18.5V7.25A2.252 2.252 0 0 0 19.75 5H6.25zm2.813 6.75a1.688 1.688 0 1 0 0-3.375 1.688 1.688 0 0 0 0 3.375z",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddPhotoUpload);
export default __webpack_public_path__ + "static/media/icon-add-photo-upload.9dc5f317.svg";
export { ForwardRef as ReactComponent };